import { contactCard } from '../../shared';

export const sellersAttorneyContactCard = contactCard(
  'additionalContacts.attorney',
  'attorney',
);
